import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Do you need to visit the property or shoot new content?",
    a: "No. We work entirely with your existing assets — phone videos, drone footage, photographer shots. Send them via Google Drive or WhatsApp and our studio handles the rest.",
  },
  {
    q: "What is Trakheesi and why does it matter for my creatives?",
    a: "Trakheesi is Dubai's real estate advertising permit system. Every property ad must display a valid permit number or QR code. We embed these seamlessly into every creative so your listings stay compliant and never get flagged or pulled down.",
  },
  {
    q: "How fast is the turnaround really?",
    a: "72 hours on Starter, 48 hours on Growth, and priority 24-hour rush delivery on Authority. The one-time Creative Sprint is delivered within 7 calendar days.",
  },
  {
    q: "Can I upgrade, downgrade or pause my package?",
    a: "Yes. Packages are month-to-month with no lock-in. You can switch tiers at the start of any billing cycle, or pause when your listing pipeline slows down.",
  },
  {
    q: "What if I don't like a creative?",
    a: "Every package includes revision rounds — one on Starter, two on Growth and Authority. We refine until it matches your brand standards.",
  },
  {
    q: "Do you work with developers or only brokerages?",
    a: "Both. We serve boutique brokerages, multi-agent agencies, master developers, off-plan specialists and investment firms across Dubai and the wider UAE.",
  },
];

export const Faq = () => {
  return (
    <section id="faqs" data-testid="faq-section" className="py-16 sm:py-24 lg:py-28 bg-[#0b1426]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="text-center"
        >
          <p className="font-code text-xs sm:text-sm uppercase tracking-[0.25em] text-[#fba31b] font-bold">FAQs</p>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Questions? <span className="text-[#fba31b]">Answered.</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-12"
        >
          <Accordion type="single" collapsible className="space-y-4">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i + 1}`}
                className="rounded-2xl border border-white/10 bg-[#162544] px-6 data-[state=open]:border-[#fba31b]/40"
              >
                <AccordionTrigger data-testid={`faq-trigger-${i + 1}`} className="text-left font-display text-base sm:text-lg font-bold hover:text-[#fba31b] hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm sm:text-base text-slate-300 leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
